import { useCallback, useEffect, useState } from "react";
import { Headset } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { ChatView } from "@/components/ChatView";
import { PageHeader, LoadingGrid, ErrorState } from "@/components/common";
import { useBranding } from "@/context/BrandingContext";

export default function CreatorMessages() {
  const { branding } = useBranding();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    try { setData((await api.get("/me/messages")).data); setError(""); } catch (e) { setError(errMsg(e)); }
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [load]);
  const send = async (payload) => { await api.post("/me/messages", payload); await load(); };
  const support = `${branding.website_name} Support`;
  return (
    <div>
      <PageHeader eyebrow="Private" title="Messages" desc={`Your private conversation with ${support}.`} />
      {error ? <ErrorState message={error} onRetry={load} /> : !data ? <LoadingGrid count={1} className="" h="h-[60vh]" /> : (
        <div className="uc-card h-[65vh] flex flex-col overflow-hidden" data-testid="creator-chat">
          <div className="px-5 py-4 border-b border-border flex items-center gap-3">
            <div className="h-10 w-10 rounded-full gold-bg grid place-items-center"><Headset className="h-4 w-4 text-black" /></div>
            <div><p className="font-medium text-sm">{support}</p><p className="text-[11px] text-muted-foreground">Admin team · usually replies within a day</p></div>
          </div>
          <div className="flex-1 min-h-0"><ChatView messages={data.messages} mineRole="creator" onSend={send} theirName={support} closed={data.thread.status === "closed"} /></div>
        </div>
      )}
    </div>
  );
}
